import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import IssueNumberService from "../services/IssueNumberService";
import MappingService from "../services/MappingService";
import { useBrand } from "./../helper/BrandContext";

const Mapping = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const issueNumberService = new IssueNumberService();
  const mappingService = new MappingService();
  const surveyLink = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    brandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    AvailableSeries: []
  });
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [AvailableSeries, setAvailableSeries] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAvailableSeries, setOpenAvailableSeries] = useState(false);
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    productId: "",
    FromNo: "",
    ToNo: "",
    issueQty: "",
    batchNo: "",
    batchSize: "",
    manufacturingDate: "",
    expiryDate: "",
    serialShippingCode: "",
    Userid: "",
    brandId: 0
  });

  const handleRowSelected = (state) => {
    setFormData((prevData) => ({
      ...prevData,
      FromNo: state.data.fromNo.toString(),
      ToNo: state.data.toNo.toString(),
      issueQty: state.data.qty.toString()
    }));
    handleCloseAvailableSeries();
  };
  const handleAvailableSeries = () => {
    // Logic to handle available series display
    setOpenAvailableSeries(true); // Show the dialog
  };
  const handleCloseAvailableSeries = () => {
    setOpenAvailableSeries(false); // Close the dialog
  };
  const [formErrors, setFormErrors] = useState({
    productId: "",
    FromNo: "",
    ToNo: "",
    issueQty: "",
    batchNo: "",
    batchSize: "",
    manufacturingDate: "",
    expiryDate: "",
    serialShippingCode: ""
  });

  const navigate = useNavigate();

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      const storedToken = sessionStorage.getItem("token");
      if (storedToken) {
        isLoggedIn(true);
        Promise.all([
          GetFromNo(),
          GetProducts(brand),
          fetchSeriesData(),
          fetchMappingData()
        ])
          .then(() => {
            // All data fetching and operations have completed
            // setState((prevData) => ({
            //   ...prevData,
            //   loading: false
            // })); // Data has loaded, set loading to false
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
            // setState((prevData) => ({
            //   ...prevData,
            //   loading: false
            // })); // Set loading to false in case of an error
          });
      } else {
        isLoggedIn(false); // User is not logged in
        navigate("/login"); // Redirect to the login page
      }
    }
  }, [isLoggedIn, navigate, setFormData, brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  const fetchSeriesData = async () => {
    try {
      issueNumberService.GetAvailableSeries().then((response) => {
        setState((prevData) => ({
          ...prevData,
          AvailableSeries: response.responseData
        }));
      });
    } catch (error) {
      console.error("Error fetching issue data:", error);
    }
  };

  function fetchMappingData() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    mappingService
      .GetMappings(tableRequest)
      .then((response) => {
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }
  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchMappingData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchMappingData();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    fetchMappingData();
  };

  function GetFromNo() {
    mappingService
      .getFromNo(brand)
      .then((response) => {
        let data = 1; // Default value in case response is null or doesn't have the expected structure
        if (
          response &&
          response.responseData &&
          response.responseData.toNo !== null
        ) {
          data = response.responseData.toNo + 1;
        }
        //console.log("first", data);
        setFormData((prevFormData) => ({
          ...prevFormData,
          FromNo: data
        }));
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }
  const handleDialogOpen = async () => {
    GetFromNo();
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormErrors({
      productId: "",
      FromNo: "",
      ToNo: "",
      issueQty: "",
      batchNo: "",
      batchSize: "",
      manufacturingDate: "",
      expiryDate: "",
      serialShippingCode: ""
    });
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "productId":
        if (value.length < 1) {
          IsValid = false;
          errors.productId = "Please select product name.";
        } else errors.productId = "";
        break;
      case "FromNo":
        if (value.length < 1) {
          IsValid = false;
          errors.FromNo = "Please enter From No.";
        } else errors.FromNo = "";
        break;
      // case "ToNo":
      //     if (value.length < 1) {
      //         IsValid = false;
      //         errors.ToNo = "Please enter To No.";
      //     } else {
      //         errors.ToNo = "";
      //     }
      //     break;
      case "issueQty":
        if (value.length < 1) {
          IsValid = false;
          errors.issueQty = "Please enter issue qty.";
        } else {
          errors.issueQty = "";
        }
        break;
      case "batchNo":
        if (value.length < 1) {
          IsValid = false;
          errors.batchNo = "Please enter batch number.";
        } else {
          errors.batchNo = "";
        }
        break;
      // case "batchSize":
      //     if (value.length < 1) {
      //         IsValid = false;
      //         errors.batchSize = "Please enter batch size.";
      //     } else {
      //         errors.batchSize = "";
      //     }
      //     break;
      case "manufacturingDate":
        if (value.length < 1) {
          IsValid = false;
          errors.manufacturingDate = "Please select manufacturing date.";
        } else if (formData.expiryDate != "" && formData.expiryDate <= value) {
          IsValid = false;
          errors.manufacturingDate =
            "manufacturing date must be less than expiry date.";
        } else {
          errors.manufacturingDate = "";
          errors.expiryDate = "";
        }
        break;
      case "expiryDate":
        if (value.length < 1) {
          IsValid = false;
          errors.expiryDate = "Please select expiry date.";
        } else if (formData.manufacturingDate >= value) {
          IsValid = false;
          errors.expiryDate =
            "Expiry date must be greater than manufacturing date.";
        } else {
          errors.expiryDate = "";
          errors.manufacturingDate = "";
        }
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    // Assuming 'issueQty' and 'FromNo' are numeric values
    if (name === "issueQty") {
      const issueQty = parseFloat(value);
      const FromNo = parseFloat(formData.FromNo); // Assuming 'FromNo' is already set

      if (!isNaN(issueQty) && !isNaN(FromNo)) {
        const ToNo = FromNo + issueQty - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: ToNo.toString() // Convert to string if necessary
        }));
        formData.issueQty = issueQty;
        formData.ToNo = ToNo.toString();
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: "" // Set to empty if values are invalid
        }));
      }
    } else if (name === "FromNo") {
      const FromNo = parseFloat(value);
      const issueQty = parseFloat(formData.issueQty); // Assuming 'FromNo' is already set

      if (!isNaN(FromNo) && !isNaN(issueQty)) {
        const ToNo = FromNo + issueQty - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: ToNo.toString() // Convert to string if necessary
        }));
        formData.ToNo = ToNo.toString();
        formData.issueQty = issueQty.toString();
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          issueQty: "" // Set to empty if values are invalid
        }));
      }
    } else if (name === "productId") {
      handleProductChange(value);
    }
    validateForm(name, value);
  };
  function GetProducts(brandId) {
    issueNumberService
      .getproducts(brandId)
      .then((response) => {
        const data = response.responseData;
        setProducts(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  const handleProductChange = (value) => {
    const selectedProductId = value;
    const selectedProduct = products.find(
      (product) => product.id === selectedProductId
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      productId: selectedProductId,
      batchSize: selectedProduct ? selectedProduct.batchSize : ""
    }));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const mnth = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    return `${mnth} ${year}`;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });
    if (isfrmvalid) {
      try {
        const formattedManufacturingDate = formatDate(
          formData.manufacturingDate
        );
        const formattedExpDate = formatDate(formData.expiryDate);
        formData.Userid = sessionStorage.getItem("userId");
        formData.brandId = brand;
        setFormData((prevData) => ({
          ...prevData,
          manufacturingDate: formattedManufacturingDate,
          expiryDate: formattedExpDate
        }));

        mappingService.CreateMapping(formData).then((res) => {
          if (res.responseCode == "200") {
            toast.success(res.responseMessage);
          } else {
            toast.error(res.responseMessage);
          }
          setFormData((prevData) => ({
            ...prevData,
            productId: "",
            FromNo: "",
            ToNo: "",
            issueQty: "",
            batchNo: "",
            batchSize: "",
            manufacturingDate: "",
            expiryDate: "",
            serialShippingCode: ""
          }));
          handleDialogClose();
          fetchMappingData();
        });
      } catch (error) {
        console.error("Error creating issue data:", error);
      }
    }
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Mapping
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        {/* <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="button" variant="contained" onClick={handleDialogOpen}
                >
                    (+) Add Mapping
                </button> */}
      </div>
    </div>
  );
  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="DeMapping Report"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="username"
                    header="User Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="productName"
                    header="SKU Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="fromNo"
                    header="From Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="toNo"
                    header="To Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="qty"
                    header="Issue Qty"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="batchNo"
                    header="Batch Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="itemBatchsize"
                    header="Batch Size"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="dateManufactur"
                    header="MFG Date"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="dateExpiry"
                    header="Exp. Date"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="formattedCreatedDate"
                    header="Created Date"
                    sortable={true}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>

            <Dialog
              open={openDialog}
              onClose={handleDialogClose}
              className="add"
            >
              {/* <DialogTitle></DialogTitle> */}
              <div className="modal-header">
                <h5 className="modal-title adduser">Add Issue Number</h5>
              </div>

              <form onSubmit={handleSubmit}>
                <DialogContent>
                  <TextField
                    margin="dense"
                    label="Sales Order Number"
                    type="text"
                    name="salesOrderNo"
                    value={formData.salesOrderNo}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.salesOrderNo}
                    helperText={formErrors.salesOrderNo}
                  />
                  <TextField
                    margin="dense"
                    label="From Number"
                    type="text"
                    name="FromNo"
                    value={formData.FromNo}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.FromNo}
                    helperText={formErrors.FromNo}
                  />
                  <TextField
                    margin="dense"
                    label="Issue Quantity"
                    type="text"
                    name="issueQty"
                    value={formData.issueQty}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.issueQty}
                    helperText={formErrors.issueQty}
                  />
                  <TextField
                    margin="dense"
                    label="To Number"
                    type="text"
                    name="ToNo"
                    value={formData.ToNo}
                    onChange={handleFormChange}
                    fullWidth
                    error={!!formErrors.ToNo}
                    helperText={formErrors.ToNo}
                  />

                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <DialogActions>
                        <Button
                          onClick={handleDialogClose}
                          className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                          type="button"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          color="primary"
                          className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                          Submit
                        </Button>
                      </DialogActions>
                    </div>
                  </div>
                </DialogContent>
              </form>
            </Dialog>
          </div>

          <Dialog open={openDialog} onClose={handleDialogClose} className="add">
            {/* <DialogTitle></DialogTitle> */}
            <div className="modal-header">
              <h5 className="modal-title adduser">Add Mapping</h5>
            </div>

            <form onSubmit={handleSubmit}>
              <DialogContent>
                <Grid container spacing={2}>
                  {/* Left column */}
                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.productId}
                    >
                      <InputLabel id="productDropdown">SKU</InputLabel>
                      <Select
                        labelId="productDropdown"
                        value={formData.productId}
                        name="productId"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300 // Set your desired maxHeight here
                            }
                          }
                        }}
                      >
                        {products &&
                          products.map((product) => (
                            <MenuItem key={product.id} value={product.id}>
                              {product.label}
                            </MenuItem>
                          ))}
                      </Select>
                      {!!formErrors.productId && (
                        <FormHelperText>{formErrors.productId}</FormHelperText>
                      )}
                    </FormControl>
                    <TextField
                      margin="dense"
                      label="From Number"
                      type="text"
                      name="FromNo"
                      value={formData.FromNo}
                      onChange={handleFormChange}
                      fullWidth
                      error={!!formErrors.FromNo}
                      helperText={formErrors.FromNo}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="Issue Quantity"
                      type="text"
                      name="issueQty"
                      value={formData.issueQty}
                      onChange={handleFormChange}
                      fullWidth
                      error={!!formErrors.issueQty}
                      helperText={formErrors.issueQty}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="To Number"
                      type="text"
                      name="ToNo"
                      disabled
                      value={formData.ToNo}
                      onChange={handleFormChange}
                      fullWidth
                      // error={!!formErrors.ToNo}
                      // helperText={formErrors.ToNo}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      label="BatchNo"
                      type="text"
                      name="batchNo"
                      value={formData.batchNo}
                      onChange={handleFormChange}
                      fullWidth
                      error={!!formErrors.batchNo}
                      helperText={formErrors.batchNo}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="Batch Size"
                      type="text"
                      name="batchSize"
                      value={formData.batchSize}
                      onChange={handleFormChange}
                      fullWidth
                      // error={!!formErrors.batchSize}
                      // helperText={formErrors.batchSize}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    {/* Date Pickers for Manufacturing and Expiry */}
                    <TextField
                      margin="dense"
                      label="Manufacturing Date"
                      type="month"
                      name="manufacturingDate"
                      value={formData.manufacturingDate}
                      onChange={handleFormChange}
                      fullWidth
                      error={!!formErrors.manufacturingDate} // Apply error style if there's an error
                      helperText={formErrors.manufacturingDate} // Display the error message
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputProps: {
                          min: "yyyy-MM"
                        }
                      }}
                    />
                    <TextField
                      margin="dense"
                      label="Expiry Date"
                      type="month"
                      name="expiryDate"
                      value={formData.expiryDate}
                      onChange={handleFormChange}
                      fullWidth
                      error={!!formErrors.expiryDate}
                      helperText={formErrors.expiryDate}
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputProps: {
                          min: "yyyy-MM"
                        }
                      }}
                    />
                    {/* <TextField
                                                    margin="dense"
                                                    label="Serial Shipping Code"
                                                    type="text"
                                                    name="serialShippingCode"
                                                    value={formData.serialShippingCode}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    error={!!formErrors.serialShippingCode}
                                                    helperText={formErrors.serialShippingCode}
                                                /> */}
                    <Button onClick={handleAvailableSeries} color="primary">
                      Available Mapping Series
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
              {/* Additional Dialog for Available Series */}
              {/* Include the Dialog component for showing available series */}
              <Dialog
                open={openAvailableSeries}
                onClose={handleCloseAvailableSeries}
                className="add"
              >
                <DialogTitle style={{ color: "white", textAlign: "center" }}>
                  Available Mapping Series
                </DialogTitle>
                <DialogContent>
                  <DataTable
                    value={state.AvailableSeries}
                    emptyMessage="No shippers data available"
                    className="p-datatable-responsive mt-4"
                    onRowClick={handleRowSelected}
                    rowClassName={() => "hover:cursor-pointer"}
                  >
                    <Column
                      field="fromNo"
                      header="From Number"
                      sortable={false}
                      style={{ width: "100px" }}
                      bodyClassName="hover:cursor-pointer"
                    />
                    <Column
                      field="toNo"
                      header="To Number"
                      sortable={false}
                      style={{ width: "100px" }}
                      bodyClassName="hover:cursor-pointer"
                    />
                    <Column
                      field="qty"
                      header="Quantity"
                      sortable={false}
                      style={{ width: "100px" }}
                      bodyClassName="hover:cursor-pointer"
                    />
                  </DataTable>
                </DialogContent>
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleCloseAvailableSeries}
                        className=" can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Close
                      </Button>
                    </DialogActions>
                  </div>{" "}
                </div>
              </Dialog>
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <DialogActions>
                    <Button
                      onClick={handleDialogClose}
                      className=" can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      type="button"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                      Submit
                    </Button>
                  </DialogActions>
                </div>{" "}
              </div>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default Mapping;
